// extracted by mini-css-extract-plugin
export var noSpinners = "_sp-6";
export var percentageInput = "_sp-7";
export var variantColor1 = "_sp-0";
export var variantColor2 = "_sp-1";
export var variantColor3 = "_sp-2";
export var variantColor4 = "_sp-3";
export var variantColor5 = "_sp-4";
export var variantColor6 = "_sp-5";